import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../../../services/notification.service';
import { JobcardService } from '../../../../../services/jobcard.service';
import { PartnerService } from '../../../../../services/partner.service';
import { TranslateService } from '@ngx-translate/core';
import { ChecklistService } from '../../../../../services/checklist.service';
import { AppConfig } from '../../../../../app.config';

@Component({
  selector: 'app-jobcard-messaging',
  templateUrl: './jobcard-messaging.component.html',
  styleUrls: ['./jobcard-messaging.component.scss'],
})
export class JobcardMessagingComponent implements OnInit {
  public athleteId = '';
  public jobcardId = '';
  public jobCardIdentifier = '';
  public partnerId = '';
  public messages: any = [];
  public partner = '';
  public jobcardno = '';
  public message = '';
  public loading = false;
  public errorMessage = '';
  public sending = false;
  //public platform = "";
  public jobCard: any = {};
  public showInvoice: boolean = false;
  public tabItems = [];
  public selectedTab = '';
  public technicianName: string = '';
  public technicianPhoto: string = '';

  showChecklists: boolean = false;

  constructor(
    public appConfig: AppConfig,
    public route: ActivatedRoute,
    public router: Router,
    public notificationService: NotificationService,
    public jobcardService: JobcardService,
    public partnerService: PartnerService,
    public checklistService: ChecklistService,
    private translate: TranslateService,
  ) { }

  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  ngOnInit() {
    this.athleteId = this.route.snapshot.paramMap.get('athleteid');
    this.jobcardId = this.route.snapshot.paramMap.get('jobcardid');
    this.partnerId = this.route.snapshot.paramMap.get('partnerid');
    this.getPatnerDataForCyclistPlatform();
    //this.platform = navigator.platform.indexOf("iPhone")>-1 ? "iOS" : navigator.platform.indexOf("Android")>-1 || navigator.platform.indexOf("Linux")>-1 ? "Android" : "Other";
  }

  ngAfterViewChecked(): void {
    this.updateScroll();
  }

  getPatnerDataForCyclistPlatform() {
    this.partnerService
      .getPartnerDataCyclistPlatform(this.jobcardId)
      .subscribe((data) => {
        this.appConfig.populateDataCyclistPlatform(data);

        this.getJobCardMessages();
        this.getFullJobCard();
      });
  }

  getFullJobCard() {
    this.jobcardService.getFullJobCardsV1(this.jobcardId, this.partnerId, this.athleteId).subscribe((jobCard) => {
      jobCard.status = this.appConfig.getPartnerCustomStatus(jobCard.statusID); //Update status to partner status or default
      console.log(jobCard);
      this.jobCardIdentifier = jobCard[0].qrCodeIdentifier;
      console.log(this.jobCardIdentifier);
      this.jobCard = jobCard;
      this.technicianName = this.jobCard.technicianName;
      this.technicianPhoto = this.jobCard.technicianPhoto;

      if (jobCard.statusID < 40) {
        this.tabItems.push({
          label: this.translate.instant('general.headers.job_card'),
          view: 'Job Card',
        });
        this.tabItems.push({
          label: this.translate.instant(
            'bikeshop.shop_setup.card_headers.message_templates',
          ),
          view: 'Messaging',
        });
        this.tabItems.push({
          label: this.translate.instant(
            'bikeshop.modal.update_job_card.tab.attachments',
          ),
          view: 'Attachments',
        });
        this.selectedTab = 'Messaging';
      } else if (jobCard.statusID === 100) {
        this.tabItems.push({
          label: this.translate.instant('general.headers.job_card'),
          view: 'Job Card',
        });
        this.tabItems.push({
          label: this.translate.instant(
            'bikeshop.shop_setup.card_headers.message_templates',
          ),
          view: 'Messaging',
        });
        this.selectedTab = 'Job Card';
      } else {
        this.tabItems.push({
          label: this.translate.instant('general.headers.job_card'),
          view: 'Job Card Completed',
        });
        this.tabItems.push({
          label: this.translate.instant(
            'bikeshop.shop_setup.card_headers.message_templates',
          ),
          view: 'Messaging',
        });
        this.tabItems.push({
          label: this.translate.instant(
            'bikeshop.modal.update_job_card.tab.attachments',
          ),
          view: 'Attachments',
        });
        this.selectedTab = 'Job Card Completed';
      }
      this.getIfChecklistsExist();
      this.checkIfApproval();
      this.checkIfMultQuoteApproval();
      console.log(this.tabItems);
    });
  }

  getJobCardMessages() {
    this.loading = true;
    this.notificationService
      .getAthleteJobMessages(this.athleteId, this.jobcardId, this.partnerId)
      .subscribe(
        (jobcardmessages) => {
          this.loading = false;
          this.partner = jobcardmessages.Partner;
          this.jobcardno = jobcardmessages.JobCardNo;
          this.messages = jobcardmessages.Messages.reverse();
          this.cleanDate();
        },
        (err) => {
          this.loading = false;
          this.errorMessage = err;
          this.messages = [];
          this.partner = '';
          this.jobcardno = '';
        },
      );
  }

  getIfChecklistsExist() {
    try {
      this.checklistService
        .getServiceChecklist(this.partnerId, this.jobcardId)
        .subscribe((res) => {
          var obj: any = [];
          if (res) {
            res.forEach((x) =>
              x.defaultValue == null ? (x.defaultValue = '') : x.defaultValue,
            );
            res.forEach((x) =>
              x.frontValue == null ? (x.frontValue = '') : x.frontValue,
            );
            res.forEach((x) =>
              x.rearValue == null ? (x.rearValue = '') : x.rearValue,
            );

            res.forEach((x) =>
              !(x.rearValue == '' && x.frontValue == '' && x.defaultValue == '')
                ? obj.push(x)
                : x,
            );
          }

          if (obj.length > 0) {
            if (this.jobCard.statusID < 40) {
              this.tabItems.push({
                label: this.translate.instant(
                  'bikeshop.modal.update_job_card.tab.checklist',
                ),
                view: 'Checklists',
              });
            } else {
              this.tabItems.push({
                label: this.translate.instant(
                  'bikeshop.modal.update_job_card.tab.checklist',
                ),
                view: 'Checklists',
              });
            }
          }
        });
    } catch (e) { }
  }

  //To fix the timezone issue :(
  cleanDate() {
    this.messages.forEach((message) => {
      message.CreatedDate = message.CreatedDate + 'Z';
    });
  }

  updateScroll() {
    try {
      if (this.myScrollContainer) {
        //this.myScrollContainer.nativeElement.scrollIntoView(true);
        this.myScrollContainer.nativeElement.scrollTop =
          this.myScrollContainer.nativeElement.scrollHeight;
      }
    } catch (err) {
      console.log(err);
    }
  }

  sendMessage() {
    this.sending = true;
    if (this.message && this.message.length > 0) {
      this.notificationService
        .createJobCardMessage(
          this.athleteId,
          this.jobcardId,
          this.partnerId,
          this.message,
        )
        .subscribe((result) => {
          this.message = '';
          this.getJobCardMessages();
          this.sending = false;
        });
    }
  }

  selectTabItem(item) {
    this.selectedTab = item.view;
  }

  checkIfApproval() {
    this.route.queryParams.subscribe((params) => {
      if (params['serviceid']) {
        var serviceId = params['serviceid'];
        if (serviceId) {
          this.tabItems.push({
            label: 'Approvals',
            view: 'Approval',
          });
          this.selectedTab = 'Approval';
        }
      }

    });
  } 

  checkIfMultQuoteApproval() {
    this.route.queryParams.subscribe((params) => {
      if (params['serviceIdentifier']) {
        var serviceId = params['serviceIdentifier'];
        if (serviceId) {
          this.tabItems.push({
            label: 'Multi quote approvals',
            view: 'MultiQuoteApproval',
          });
          this.selectedTab = 'MultiQuoteApproval';
        }
      }

    });
  }
}
